export const MIN_YEAR = 1970;
export const MAX_YEAR = 3000;
